import React from 'react';

export interface ChartFrameProps {
    /** Chart title rendered inside the border (passed as data from the catalog). */
    title?: string;
    /** Short type tag shown top-right (e.g. LINE, BAR, PIE). */
    badge?: string;
    className?: string;
    children: React.ReactNode;
}

/**
 * Single bordered card shared by every chart/table component. Draws the one
 * border plus the header (title left, type badge right) inside it — so callers
 * never wrap charts in their own bordered/titled card.
 */
const ChartFrame: React.FC<ChartFrameProps> = ({
    title,
    badge,
    className = 'w-full h-full',
    children,
}) => (
    <div
        className={`${className} flex flex-col bg-white rounded-theme border border-gray-200 shadow-sm p-4 sm:p-6`}
    >
        {(title || badge) && (
            <div className="mb-5 flex shrink-0 items-start justify-between gap-2">
                {title && (
                    <h3 className="text-sm sm:text-base font-bold text-gray-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                        {title}
                    </h3>
                )}
                {badge && (
                    <span className="mt-0.5 shrink-0 whitespace-nowrap rounded-theme bg-gray-50 px-2 py-1 text-[9px] sm:text-xxs font-bold uppercase tracking-wider text-gray-400">
                        {badge}
                    </span>
                )}
            </div>
        )}
        <div className="relative min-h-0 flex-1">{children}</div>
    </div>
);

export default ChartFrame;
